import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query';
import { buildSwapTx } from '../../api';

export default function useBuildSwapTx(
  params: {
    fromChainid: number;
    toChainid: number;
    fromAddress: string;
    toAddress: string;
    amount: string;
    slippage: number;
    fromWalletAddress: string;
    toWalletAddress: string;
  },
  options?: {
    refetchInterval?: boolean;
  }
) {
  return useQuery({
    queryKey: ['getSwapAllTokensV2Search', JSON.stringify(params)],
    queryFn: async () => {
      return await buildSwapTx(params);
    },
    refetchInterval: options.refetchInterval ? 2000 : false,
  });
}
